import { useTranslation } from 'react-i18next';

import AlertModal from 'components/AlertModal/AlertModal';
import ConfirmModal from 'components/ConfirmModal/ConfirmModal';
import Text from 'components/Text/Text';
import { EditSessionConfirmModalDuration, EditSessionDuration } from 'config/constants';
import { Dayjs } from "utils/dayjs";

interface ReservationSidebarModalsProps {
    showDeleteConfirm: boolean
    isDeleteInProgress?: boolean
    onDeleteConfirm: (overrideOwnership?: boolean) => void
    onDeleteCancel: () => void
    showReopenConfirm: boolean
    isReopenInProgress?: boolean
    onReopenConfirm: (overrideOwnership?: boolean) => void
    onReopenCancel: () => void
    showReservationLockedByAnotherUserError?: boolean
    showReservationUpdatedByAnotherUserError?: boolean
    onResetError: () => void
    errorEmail: string
    errorDate?: Dayjs | null
}

const ReservationSidebarModals = ({
    showDeleteConfirm,
    isDeleteInProgress,
    onDeleteConfirm,
    onDeleteCancel,
    showReopenConfirm,
    isReopenInProgress,
    onReopenConfirm,
    onReopenCancel,
    showReservationLockedByAnotherUserError = false,
    showReservationUpdatedByAnotherUserError = false,
    errorEmail,
    errorDate,
    onResetError
}: ReservationSidebarModalsProps) => {
    const { t } = useTranslation()

    return (
        <>
            {showDeleteConfirm &&
                <ConfirmModal
                    theme="danger"
                    title={t('common.warning')}
                    maxWidth="640px"
                    isBusy={isDeleteInProgress}
                    onConfirm={() => onDeleteConfirm()}
                    onClose={onDeleteCancel}
                    confirmButtonLabel={t('common.delete')}>
                    {t('reservation.deleteConfirm')}
                </ConfirmModal>
            }
            {showReopenConfirm &&
                <ConfirmModal
                    title={t('common.attention')}
                    maxWidth="586px"
                    isBusy={isReopenInProgress}
                    onConfirm={() => onReopenConfirm()}
                    onClose={onReopenCancel}
                    confirmButtonLabel={t('reservation.reopenRequest')}>
                    {t('reservation.reopenConfirm')}
                </ConfirmModal>
            }
            {showReservationLockedByAnotherUserError &&
                <AlertModal
                    title={t('common.attention')}
                    theme="secondary"
                    maxWidth="640px"
                    onClose={onResetError}>
                    <Text className="white-space-pre-line">{t('reservation.lockedByDifferentUserX', { email: errorEmail || "", duration: EditSessionDuration.asMinutes() + EditSessionConfirmModalDuration.asMinutes() })}</Text>
                </AlertModal>
            }
            {showReservationUpdatedByAnotherUserError &&
                <ConfirmModal
                    theme="danger"
                    title={t('common.warning')}
                    maxWidth="640px"
                    onClose={onResetError}
                    onConfirm={() => onDeleteConfirm(true)}
                    confirmButtonLabel={t('common.confirm')}
                    isBusy={isDeleteInProgress}>
                    <Text className="white-space-pre-line">{t('reservation.updatedByDifferentUserX', { email: errorEmail || "", date: errorDate?.format(t('config.dateLongTimeFormat')) || "" })}</Text>
                </ConfirmModal>
            }
        </>
    )
};

export default ReservationSidebarModals;
